import React, { Component } from 'react';
import './Ledger.css';
import Transaction from './Transaction';
import TransactionInput from './TransactionInput';
import AccountForm from './AccountForm';
import NumberFormat from 'react-number-format';

// import { Dropdown, DropdownButton, MenuItem, ButtonToolbar } from 'react-bootstrap';

class LedgerShell extends Component {
    constructor(props) {
        super();
        this.intl = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        this.buttonBlue = { backgroundColor: '#8BA6A9', borderColor: '#8BA6A9' };
        this.state = {
            balance: '',
            withdrawAmount: 0,
            depositAmount: 0,
            withdrawClicked: false,
            transactions: []
        };

        this.withdrawOrDepositUI = this.withdrawOrDepositUI.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.depositOrWithdrawClicked = this.depositOrWithdrawClicked.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    componentDidMount() {
    }

    handleAccountChange(account) {
        this.setState({account: account});
        console.log("load account data...", account);

        let options = this.props.fetchOptions();

        this.setState({ balance: account.balance});

        options.accountID = account.id;
        options.method = "GET";

        fetch("/api/transactions/" + account.id, options)
            .then(res => res.json())
            .then(payload => {
                if (payload.message) { // If the token isn't valid...
                    alert(payload.message);
                } else { // If it is...
                    console.log("transactions: ", payload);
                    this.setState({ transactions: payload.transactions });
                }
            }).catch(() => alert("An unknown error occured."));
    }

    depositOrWithdrawClicked(event) {
        let regex = /^[0-9]\d*(()?(\.\d{0,2})?)$/;
        let url = this.state.withdrawClicked ? "/api/withdraw" : "/api/deposit";
        let options = {
            method: "PUT",
            body: JSON.stringify({
                [event.target.name]: this.state[event.target.name],
                ...this.props.user
            }),
            headers: {
                "Content-Type": "application/json"
            }
        }

        if (!regex.test(this.state[event.target.name])) {
            alert("Incorrect Format!");
        } else {
            fetch(url, options)
                .then(res => res.json())
                .then(payload => {
                    if (payload.message) { // If the token or money format isn't valid...
                        alert(payload.message);
                    } else { // if it is...
                        this.setState({ balance: this.intl.format(payload.balance), transactions: [...this.state.transactions, payload] });
                    }
                }
                ).catch(() => alert("An unknown error occured."));
        }
    }

    handleChangeInput(event) {
        this.setState({
            [event.target.name]: event.target.value,
        });
    }

    // The input where the user enters a number.
    withdrawOrDepositUI() {
        return (
            <div className="form-group">
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text">$</span>
                    </div>
                    <input
                        name={this.state.withdrawClicked ? "withdrawAmount" : "depositAmount"}
                        value={this.state.withdrawClicked ? this.state.withdrawAmount : this.state.depositAmount}
                        onChange={this.handleChangeInput}
                        type="number"
                        className="form-control"
                        placeholder={this.state.withdrawClicked ? "Enter withdrawl amount here..." : "Enter deposit amount here..."}>
                    </input>
                    <div className="input-group-append">
                        <button
                            onClick={this.depositOrWithdrawClicked}
                            name={this.state.withdrawClicked ? "withdrawAmount" : "depositAmount"}
                            className="btn btn-outline-secondary"
                            type="button">
                            {this.state.withdrawClicked ? "Make Withdrawal" : "Make Deposit"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="container-fluid">
                <div className="col-md-10 col-lg-10 col-xl-10">
                    <div className="row">
                    <div className="col-sm-2">
                            <AccountForm
                                user={this.props.user}
                                fetchOptions={this.props.fetchOptions}
                                onAccountChange={this.handleAccountChange}
                            />
                        </div>

                        <div className="col-sm-5">
                            { this.state.balance ?
                                <button className="btn btn-primary balanceText">
                                Balance: <NumberFormat
                                    value={this.state.balance}
                                    displayType={'text'}                                            decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    prefix={'$'} />
                                </button>
                                : ""
                            }
                        </div>
                        <div className="col-sm-2 logoutButton">
                            <button onClick={() => this.props.destroySession()} className="btn btn-primary logoutButton">Log Out</button>
                        </div>
                    </div>
                    { this.state.account && this.state.account.access === "write" && <TransactionInput />
                    }

                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Note</th>
                                <th>Amount</th>
                                <th>Available Balance</th>
                        </tr>
                        </thead>
                        <tfoot><tr><td></td><td></td><td></td><td></td></tr></tfoot>
                        <tbody className="ledgerItemHolder">
                            {/* {console.log("TRANSACTIONS: ", this.state.transactions)} */}
                            {this.state.transactions.map((item) => <Transaction
                               key={item.id} tr={item} />).reverse()}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default LedgerShell;


// WEBPACK FOOTER //
// ./src/Components/Ledger/LedgerShell.js